/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { SlOptions } from "react-icons/sl";
import { useRequestStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";
import { LoadMore, MainPaginate } from "../app/buttons";
// import moment from "moment";
import { DeleteModal } from "../modals/donemodal";
import useErrorStore from "../../data/stores/errorStore";
import { toast } from "react-toastify";
import { TableTopSearch } from "./tools-table";
import { ActionButton } from "../../pages/new-request/[id]";

const ToolsTable = ({ tab, tabs }) => {
  const [openPopup, setOpenPopup] = useState(null);
  // const navigate = useNavigate();
  const popupRef = useRef(null),
    [modal, setModal] = useState<any>(null);
  const togglePopup = (id) => {
    if (openPopup === id) {
      setOpenPopup(null);
    } else {
      setOpenPopup(id);
    }
  };
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     // Close popup if click is outside the popup and the icon
  //     if (popupRef.current && !popupRef.current.contains(event.target)) {
  //       setOpenPopup(null);
  //     }
  //   }

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [popupRef]);
  // const data = [
  //   {
  //     name: "integreted management information system",
  //     level: "utility",
  //     website: "lims.com",
  //     date: "11/09/22",
  //   },
  //   {
  //     name: "integreted management information system",
  //     level: "utility",
  //     website: "lims.com",
  //     date: "11/09/22",
  //   },
  //   {
  //     name: "integreted management information system",
  //     level: "utility",
  //     website: "lims.com",
  //     date: "11/09/22",
  //   },
  // ];
  // const options = [
  // 	{
  // 		icon: Check,
  // 		name: "view tool",
  // 		color: "#505666",
  // 		action: state =>
  // 			navigate(`/tools/${state?.toolName || openPopup}`, { state }),
  // 	},
  // 	{
  // 		icon: Check,
  // 		name: "edit tool",
  // 		color: "#505666",
  // 		action: state => navigate(`/tools/add-tool`, { state }),
  // 	},
  // 	{
  // 		icon: Delete,
  // 		name: "delete tool",
  // 		color: "#C5292A",
  // 		action: sta => {
  // 			setModal([sta]);
  // 			setOpenPopup(null);
  // 		},
  // 	},
  // ];

  let [datum, setDatum] = useState<any>({ docs: [] }),
    {
      getLogger,
      mainSearch,
      isFound,
      data,
      recent,
      getDynamicLogger,
      deleteDynamicLogger,
      pending,
      completed,
      invited,
    }: any = useRequestStore(),
    [loading, setLoading] = useState<string | boolean>(false);

  useEffect(() => {
    if (isFound) setDatum(mainSearch);
    else if (tab === "pending") setDatum(pending);
    else if (tab === "completed") setDatum(completed);
    else if (tab === "invited") setDatum(invited);
    else setDatum(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isFound, mainSearch, tab, recent, pending, completed, invited]);

  const handleLoadMore = async () => {
    setLoading("loadmore");
    await apiCall({
      type: "get",
      url: `/api/v1/tools/new-request?limit=${datum?.limit * datum?.nextPage}${
        tab !== "all" ? `&statusText=${tab}` : ""
      }`,
      getter: (d: any) =>
        tab !== "all" ? getDynamicLogger(d, tab) : getLogger(d),
    });
    setLoading(false);
  };

  let { returnErrors } = useErrorStore();
  const onSubmit = async () => {
    setLoading("delete");

    let { response, errArr, errMsg } = await apiCall({
      type: "delete",
      url: `/api/v1/tools/new-request`,
      data: {
        requests: modal?.map((it: any) => {
          return { requestId: it?._id };
        }),
      },
    });
    // console.log({ response, errArr, errMsg });
    if (errArr) {
      setLoading(false);
      return returnErrors(errArr);
    }
    if (errMsg) {
      setLoading(false);
      return toast.error(errMsg);
    }
    setLoading(false);
    if (response) {
      modal.forEach((element: any) => {
        deleteDynamicLogger(element, "data");
        deleteDynamicLogger(element, "recent");
      });
      setModal(null);
      return;
    }
    setLoading(false);
    setLoading(false);
  };

  const [itemOffset, setItemOffset] = useState(0);
  let [range] = useState(10);
  const endOffset = itemOffset + range;

  // if (!datum && !data) return <PageLoader />;
  if (!datum) return;

  const currentItems = datum?.docs?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(datum?.docs?.length / range);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * range) % datum?.docs?.length;
    setItemOffset(newOffset);
  };

  return (
    <div>
      <TableTopSearch
        data={datum}
        setData={setDatum}
        handleDelete={() => {
          setModal(datum?.docs?.filter((iz: any) => iz?.isChecked));
        }}
      />
      <table className="table-auto w-full">
        <thead className="grid grid-cols-9 items-center bg-[#F2FBFF] text-base font-medium text-da-blue-700 h-11 w-full px-8">
          <th className="col-span-2 text-left px-4">Tool Name</th>
          <th className="col-span-1 text-left px-4">Region/Country</th>
          <th className="col-span-2 text-left px-4">Email Address</th>
          <th className="col-span-1 text-left px-4">Tool Type</th>
          <th className="col-span-1 text-left px-4">Rating</th>
          <th className="col-span-2 text-left px-4">Status</th>
        </thead>
        <tbody>
          {currentItems?.map((it: any, i: number) => (
            <tr
              key={i}
              className="grid grid-cols-9 text-left px-8 text-base font-normal text-da-blue-800 items-center bg-transparent border-b border-b-[#eee]"
            >
              <td className="col-span-2 h-14 flex gap-4 items-center px-4">
                <input
                  type="checkbox"
                  name=""
                  className="form-checkbox size-5 border border-[#ccc]"
                  id={it?._id}
                  onChange={(e) => {
                    let dd = datum?.docs;
                    let current = it;
                    if (e?.target?.checked) {
                      current = {
                        ...current,
                        isChecked: true,
                      };
                    } else {
                      current = {
                        ...current,
                        isChecked: false,
                      };
                    }
                    dd = dd?.map((ic) => (ic?._id === it?._id ? current : ic));
                    setDatum({ ...datum, docs: dd });
                  }}
                  checked={it?.isChecked}
                />
                <span className="text-base font-normal first-letter:uppercase text-da-blue-800">
                  {it?.tool?.toolName || it?.toolName || it?.organizationName}
                </span>
              </td>
              <td className="first-letter:uppercase px-4">
                <CheckRegion it={it} />
                {it?.tool?.toolSelection?.find(
                  (ic: { category: string; data?: string[] }) =>
                    ic?.category === "COUNTRY"
                )?.data?.[0] || it?.country}
              </td>
              <td className="col-span-2 px-4">
                {it?.tool?.contactEmailAddress || it?.contactEmailAddress}
              </td>
              <td className=" px-4">
                {it?.tool?.toolSelection?.find(
                  (ic: { category: string; data?: string[] }) =>
                    ic?.category === "APPLICATION LEVEL"
                )?.data?.[0] || it?.toolCategory}
              </td>
              <td className="px-4">
                <ScorePill score={it?.tool?.score ?? it?.score} />
              </td>
              <td className=" col-span-2 grid grid-cols-3 gap-8 items-center first-letter:uppercase relative px-4">
                <span
                  className={`capitalize col-span-2 text-center rounded-md px-3 py-1 ${
                    ["accepted", "completed"]?.includes(it?.statusText)
                      ? "bg-[#F0FDF4] text-[#16A34A]"
                      : ["rejected", "canceled"]?.includes(it?.statusText)
                      ? "bg-[#FEF2F2] text-[#DC2626]"
                      : "bg-[#FEFCE8] text-[#CA8A04]"
                  }`}
                >
                  {it?.statusText}
                </span>
                {/* <span>{moment(it?.createdAt).format("DD-MM-YYYY")}</span> */}
                <SlOptions
                  onClick={() => togglePopup(i)}
                  className="cursor-pointer"
                  color="#404040"
                />
                {openPopup === i && (
                  <div
                    style={{
                      boxShadow: "0px 10px 40px 0px #0000001A",
                    }}
                    className="absolute left-2 top-4 mt-2 p-5 bg-white shadow-lg rounded z-10"
                  >
                    <div className="space-y-3">
                      {/* {options?.map((op, idx) => (
												<button
													key={idx}
													onClick={() => (op?.action ? op?.action(it) : {})}
													ref={popupRef}
													className={`h-9 w-32 ${
														idx === 0 && "bg-[#F4F4F4]"
													} bg-transparent flex gap-3 rounded-lg items-center`}>
													<img src={op?.icon} alt="" className="" />
													<span
														style={{
															color: op?.color,
														}}
														className="font-normal capitalize text-sm">
														{op?.name}
													</span>
												</button>
											))} */}

                      <ActionButton
                        item={it}
                        usecase="table"
                        popupRef={popupRef}
                        setModal={setModal}
                        setOpenPopup={setOpenPopup}
                        openPopup={openPopup}
                        tab={tab}
                      />
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-10 flex justify-center w-44 items-center mx-auto">
        <LoadMore
          next={data?.hasNextPage}
          loading={loading === "loadmore"}
          handleLoadMore={handleLoadMore}
        />
      </div>
      {pageCount > 1 && (
        <MainPaginate pageCount={pageCount} handlePageClick={handlePageClick} />
      )}
      {modal && (
        <DeleteModal
          page={"Tool"}
          close={onSubmit}
          handleClose={() => setModal("")}
          loading={loading === "delete"}
        />
      )}
    </div>
  );
};

export default ToolsTable;

export const CheckRegion = ({ it }: { it: any }) => {
  const region =
    it?.tool?.toolSelection?.find(
      (ic: { category: string; data?: string[] }) => ic?.category === "REGION"
    )?.data?.[0] || it?.region;

  return (
    <>
      {region}
      {region ? "/" : ""}
    </>
  );
};

export const ScorePill = ({ score }: { score?: number | string | null }) => {
  if (score === null || score === undefined || score === "") {
    return (
      <span className="inline-flex items-center rounded-full px-3 py-1 text-sm font-medium bg-gray-100 text-gray-600">
        -
      </span>
    );
  }

  const numericScore = typeof score === "string" ? parseFloat(score) : score;
  if (Number.isNaN(numericScore)) {
    return (
      <span className="inline-flex items-center rounded-full px-3 py-1 text-sm font-medium bg-gray-100 text-gray-600">
        -
      </span>
    );
  }

  // Low: 0-40 (red), Medium: 41-70 (yellow), High: 71-100 (green)
  let bgColor = "";
  let textColor = "";

  if (numericScore >= 0 && numericScore <= 40) {
    bgColor = "bg-[#FEF2F2]";
    textColor = "text-[#DC2626]";
  } else if (numericScore >= 41 && numericScore <= 70) {
    bgColor = "bg-[#FEFCE8]";
    textColor = "text-[#CA8A04]";
  } else if (numericScore >= 71 && numericScore <= 100) {
    bgColor = "bg-[#F0FDF4]";
    textColor = "text-[#16A34A]";
  } else {
    bgColor = "bg-gray-100";
    textColor = "text-gray-600";
  }

  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-sm font-medium ${bgColor} ${textColor}`}
    >
      {numericScore}
    </span>
  );
};
